@if ((entityAccountGroupName$ | async) !== 'merchants' || (entityAccountGroupName$ | async) !== 'affiliates') {
  <app-non-supported-groups [supportedGroups]="['merchants', 'affiliates']"></app-non-supported-groups>
}
<div [style.display]="((entityAccountGroupName$ | async) === 'merchants' || (entityAccountGroupName$ | async) === 'affiliates')  ? null : 'none'">
  <mat-drawer-container>
    <mat-drawer #sidenav [mode]="mobileQuery().matches ? 'over' : 'side'" position="start" [opened]="drawerOpened()" (openedStart)="drawerOpened.set(true)" (closedStart)="drawerOpened.set(false)">
      <div class="drawer-lining">
        <div class="close-wrapper">
          <h2>Filters</h2>
          <button mat-icon-button class="close-button" (click)="sidenav.close()"><mat-icon>close</mat-icon></button>
        </div>
        <mat-divider></mat-divider>
        <mat-form-field floatLabel="always">
          <mat-label>Discount Title</mat-label>
          <input [formControl]="filterControls.titleInput" matInput placeholder="Search">
        </mat-form-field>
        <mat-form-field floatLabel="always">
          <mat-label>Discount Details</mat-label>
          <input [formControl]="filterControls.detailsInput" matInput placeholder="Search">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Discount Type</mat-label>
          <mat-select [formControl]="filterControls.typeSelect" #discountTypeSelect (click)="triggerAnalytics('Discounts_DiscountType_filter', 'Discounts')">
            @for (discountTypeOption of ['all', 'automatic', 'coupon']; track discountTypeOption) {
              <mat-option [value]="discountTypeOption">{{discountTypeOption | titlecase}}</mat-option>
            }
          </mat-select>
          <mat-hint *ngIf="discountTypeSelect.value === 'automatic'">Discounts that apply with no coupon code</mat-hint>
          <mat-hint *ngIf="discountTypeSelect.value === 'coupon'">Discounts that require a coupon code to apply</mat-hint>
        </mat-form-field>
        @if ((entityAccountGroupName$ | async) === 'merchants') {
          <mat-form-field floatLabel="always">
            <mat-label>Affiliate</mat-label>
            <input type="text"
                   placeholder="Search Affiliate or Tag Group"
                   aria-label="Affiliate"
                   matInput
                   [formControl]="filterControls.affiliateAutoComplete"
                   [matAutocomplete]="affiliateAuto"
                   #affiliateInput
                   (click)="triggerAnalytics('Discounts_Affiliate_filter', 'Discounts')">
            <mat-autocomplete #affiliateAuto="matAutocomplete" [displayWith]="affiliateFilterDisplayWith" hideSingleSelectionIndicator="true"
                              (optionSelected)="onSelectedAffiliateFilterAutoComplete($event, affiliateInput)" (opened)="onOpenAutoSelect(filterControls.affiliateAutoComplete)" (closed)="onCloseAffiliateFilterAutoComplete()">
              <mat-option [value]="allAffiliatesOption" class="autocomplete-option">{{allAffiliatesOption.affiliate_name}}</mat-option>
              @for (affiliateOption of affiliateFilteredOptionsLimited$ | async; track affiliateOption.affiliate_website_id) {
                <mat-option class="autocomplete-option" [value]="affiliateOption">
                  <div class="mat-subtitle-2">{{affiliateOption.affiliate_name}}</div>
                  <div class="mat-body-2">{{affiliateOption.affiliate_website_url_protocol_stripped}}</div>
                  <span class="circle circle-green">&nbsp;</span>
                  <span><mat-icon [svgIcon]="affiliateOption.affiliate_network"></mat-icon></span>
                  <span class="classic-id mat-caption">{{affiliateOption.classic_affiliate_id}}</span>
                </mat-option>
              }
              <mat-divider></mat-divider>
              <mat-optgroup [label]="'Tag Groups'">
                @for (tagOption of userTagFilteredOptionsLimited$ | async; track tagOption.tag_id) {
                  <mat-option class="autocomplete-tag-option" [value]="tagOption">
                    <span><mat-icon aria-hidden="false" aria-label="Tag Group icon" color="accent">groups</mat-icon></span><span class="mat-body-2">{{tagOption.tag_name | titlecase}}</span>
                  </mat-option>
                }
              </mat-optgroup>
              @if ((affiliateFilteredOptions$ | async)?.length > affiliateOptionLimit || (userTagFilteredOptions$ | async)?.length > tagGroupOptionLimit) {
                <mat-option [disabled]="true" class="autocomplete-option">
                  <p class="mat-subtitle-2">Filter to see more results.</p>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        @if ((entityAccountGroupName$ | async) === 'affiliates') {
          <mat-form-field floatLabel="always" class="merchants-filter-form-field">
            <mat-label>Merchants</mat-label>
            <input matInput placeholder="Merchant Name, URL, Classic ID" [matAutocomplete]="merchantAutoComplete" [formControl]="filterControls.merchantAutoComplete" #merchantsInput spellcheck="false" (click)="triggerAnalytics('Discounts_Merchant_filter', 'Discounts')">
            <mat-error>{{filterControls.merchantAutoComplete.errors | validationMessage}}</mat-error>
            <mat-autocomplete #merchantAutoComplete="matAutocomplete" [displayWith]="merchantFilterDisplayWith"
                              (optionSelected)="onSelectedMerchantFilterAutoComplete($event, merchantsInput)" (opened)="onOpenedAutoSelect(filterControls.merchantAutoComplete)" (closed)="onClosedMerchantFilterAutoComplete()">
              <mat-option [value]="allMerchantsOption" class="autocomplete-option">
                <p class="mat-subtitle-2">All Merchants</p>
              </mat-option>
              <mat-option *ngFor="let merchant of merchantFilteredOptionsLimited$ | async" [value]="merchant" class="autocomplete-option">
                <div class="mat-subtitle-2">{{merchant.merchant_name}}</div>
                <div class="mat-body-2">{{merchant.merchantWebsiteUrlStripped}}</div>
                <span class="circle" [ngClass]="merchant.merchant_status === 'active' && merchant.relationship_status === 'active' ? 'circle-green' : 'circle-red'">&nbsp;</span><span><mat-icon [svgIcon]="merchant.merchant_network"></mat-icon></span><span class="classic-id mat-caption">{{merchant.classic_merchant_id}}</span>
              </mat-option>
              <mat-option *ngIf="(merchantFilteredOptions$ | async)?.length > merchantOptionLimit" [disabled]="true" class="autocomplete-option">
                <p class="mat-subtitle-2">Results limited. Filter to see more results.</p>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        }
        <mat-form-field floatLabel="always">
          <mat-label>Coupon Code</mat-label>
          <input [formControl]="filterControls.couponCodeInput" matInput placeholder="Search" (focus)="triggerAnalytics('Discounts_CouponCode_filter', 'Discounts')">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Rule Type</mat-label>
          <mat-select [formControl]="filterControls.ruleTypeSelect" #ruleTypeSelect (click)="triggerAnalytics('Discounts_RuleType_filter', 'Discounts')" [disabled]="this.showRestrictedCoupons()" >
            @for (discountRuleTypeOption of ruleTypeSelectOptions; track discountRuleTypeOption) {
              <mat-option [value]="discountRuleTypeOption">{{discountRuleTypeOption | titlecase}}</mat-option>
            }
          </mat-select>
             @if ((entityAccountGroupName$ | async) === 'merchants' && ruleTypeSelect.value === 'exclusive') {
              <mat-hint>Commission an affiliate on all orders that use a specific coupon code</mat-hint>
             } @else if ((entityAccountGroupName$ | async) === 'merchants' && ruleTypeSelect.value === 'restricted') {
              <mat-hint>Prevent affiliates from earning commissions when a specific coupon code is used</mat-hint>
             } @else if ((entityAccountGroupName$ | async) === 'merchants' && ruleTypeSelect.value === 'qualified') {
              <mat-hint>Commission specific affiliate(s) when both an affiliate click and a coupon code are used on an order</mat-hint>
             } @else if ((entityAccountGroupName$ | async) === 'affiliates' && ruleTypeSelect.value === 'exclusive') {
              <mat-hint>Receive commissions on orders that use a specific coupon code</mat-hint>
             } @else if ((entityAccountGroupName$ | async) === 'affiliates' && ruleTypeSelect.value === 'restricted') {
              <mat-hint>Commissions will not be earned on sales with a specific coupon code</mat-hint>
             } @else if ((entityAccountGroupName$ | async) === 'affiliates' && ruleTypeSelect.value === 'qualified') {
              <mat-hint>In order to earn commission with this code both an affiliate click and a coupon code is needed on the sale</mat-hint>
             }
        </mat-form-field>

        @if ((entityAccountGroupName$ | async) === 'merchants') {
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select [formControl]="filterControls.statusSelect" (click)="triggerAnalytics('Discounts_Status_filter', 'Discounts')">
              @for (discountStatusOption of ['all', 'active', 'expired', 'scheduled']; track discountStatusOption) {
                <mat-option [value]="discountStatusOption">{{discountStatusOption | titlecase}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if ((entityAccountGroupName$ | async) === 'affiliates') {
        <div class="close-wrapper">
          <h2>Settings</h2>
        </div>
        <mat-divider></mat-divider>
          <mat-label>View Restricted Coupon Code Rules </mat-label>
          <mat-slide-toggle [formControl]="affiliateFilterControls.seeRestricted" class="see-restricted-toggle"></mat-slide-toggle>
        }
      </div>
    </mat-drawer>
    <mat-drawer-content>
      <mat-card class="header-card" appearance="raised" [style.margin-left]="drawerOpened() ? '2%' : '5%'" [style.margin-right]="drawerOpened() ? '2%' : '5%'">
        @if ((entityAccountGroupName$ | async) === 'merchants') {
          <div>
            <mat-card-title>Discounts</mat-card-title>
            @if ((isShopifyClient$ | async) === true) {
              @if ((isShopifySyncOn$ | async) === true) {
                <mat-card-subtitle>Discounts are currently being synced from Shopify. Not all details can be edited and discounts must be deleted directly in Shopify.</mat-card-subtitle>
                @if (showProcessingSync()) {
                  <div class="connect-div">Edit Integration</div>
                } @else {
                  <div class="connect-div bulk-load-link" (click)="onClickOpenShopifyModal()">Edit Integration</div>
                }
              } @else {
                <mat-card-subtitle>Manage the discounts and coupon codes that are available to your affiliate partners via the AvantLink dashboard and AvantLink API. Shopify Sync available.</mat-card-subtitle>
                @if (showProcessingSync()) {
                  <div class="connect-div disabled-connect">Connect</div>
                } @else {
                  <div class="connect-div bulk-load-link" (click)="onClickOpenShopifyModal()">Connect</div>
                }
              }
            } @else {
              <mat-card-subtitle>Manage the discounts and coupon codes that are available to your affiliate partners via the AvantLink dashboard and AvantLink API.</mat-card-subtitle>
            }
          </div>
          <div>
            @if((showProcessingSync() === true) || ((isShopifyClient$ | async) === true) && ((isShopifySyncOn$ | async) === true)) {
              <div matTooltip="Cannot manually create Discounts with Shopify Sync turned on">
                <button mat-raised-button color="primary"
                        (click)="onClickCreateDiscountButton(); triggerAnalytics('Discounts_CreateDiscount_button', 'Discounts')"
                        disabled>Create Discount</button>
              </div>
            } @else {
              <button mat-raised-button color="primary" (click)="onClickCreateDiscountButton(); triggerAnalytics('Discounts_CreateDiscount_button', 'Discounts')">Create Discount</button>
            }
          </div>
        } @else {
          <div>
            <mat-card-title>Discounts</mat-card-title>
            <mat-card-subtitle>Merchant provided discounts and coupon codes. <a href="{{environment.supportUrl}}/hc/en-us/articles/29868262811675-Discounts-Affiliate-User-Guide-Discounts-Promotions-Coupon-Codes" target="_blank" (click)="triggerAnalytics('Discounts_LearnMore_link', 'Discounts')">Learn More</a></mat-card-subtitle>
          </div>
        }
      </mat-card>
      <mat-card appearance="raised" [style.margin-left]="drawerOpened() ? '2%' : '5%'" [style.margin-right]="drawerOpened() ? '2%' : '5%'">
        <div class="shopify-sync-progress-container" [style.display]="showProcessingSync() ? null : 'none'">
          <mat-card-title class="shopify-progress-header">Shopify Sync in progress.</mat-card-title>
          <mat-card-subtitle style="margin-bottom: 32px;">Import times will vary depending on the volume of discounts on your Shopify account. The initial sync to AvantLink may take anywhere from less than a minute up to 12 hours.</mat-card-subtitle>
          <mat-spinner color="accent"></mat-spinner>
        </div>
        <div class="loading-shade-container" [style.display]="showProcessingSync() ? 'none' : null">
          @if (isLoadingResults()) {
            <div class="loading-shade">
              <mat-spinner color="accent"></mat-spinner>
            </div>
          }
          <div class="global-table-icons">
            @if(((entityAccountGroupName$ | async) === 'merchants') && ((isShopifyClient$ | async) === false || (isShopifySyncOn$ | async) === false)) {
              <mat-checkbox
                (change)="onMasterToggleChange($event)"
                [indeterminate]="discountsSelection.selected.length > 0 && discountsSelection.selected.length !== dataSource().length"
                [checked]="!isLoadingResults() && discountsSelection.selected.length > 0 && discountsSelection.selected.length === dataSource().length">
              </mat-checkbox>
            }
            <button mat-icon-button matTooltip="Toggle Filter" (click)="sidenav.toggle()"><mat-icon color="accent">filter_list</mat-icon></button>
            @if (isDownloadingDiscounts()) {
              <div>
                <mat-spinner [diameter]="18" [color]="'accent'"></mat-spinner>
              </div>
            } @else {
              <button mat-icon-button matTooltip="Download Discounts" (click)="onDownloadClick()"><mat-icon color="accent">download</mat-icon></button>
            }
            <button #customizeColumnTrigger mat-icon-button matTooltip="Customize Display" (click)="onCustomizeDisplayClick()"><mat-icon color="accent">settings</mat-icon></button>
          </div>
          <mat-chip-listbox class="chip-list">
            @for (chip of filterChips(); track chip.displayValue) {
              <mat-chip class="blue" (removed)="onRemoveChipClick(chip)">{{chip.displayValue}}
                <button matChipRemove [attr.aria-label]="'remove ' + chip.displayValue">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </mat-chip-listbox>
          <div class="table-container">
            <table mat-table matSort matSortDisableClear [dataSource]="dataSource()">
              <ng-container matColumnDef="edit_action">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let row" class="action-button">
                  <div class="edit-action-column">
                    @if((isShopifyClient$ | async) === false || (isShopifySyncOn$ | async) == false) {
                      <mat-checkbox (click)="$event.stopPropagation();"
                      (change)="$event ? discountsSelection.toggle(row) : null"
                      [checked]="discountsSelection.isSelected(row)">
                      </mat-checkbox>
                    }
                    <button mat-icon-button matTooltip="Edit" (click)="onEditDiscountClick(row); triggerAnalytics('Discounts_EditDiscount_icon', 'Discounts')"><mat-icon color="accent">edit</mat-icon></button>
                    @if(row.showNewLabel) {
                      <div>
                        <span class="chip-like new-label" matTooltip="Modified within seven days">New</span>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="get_link_action">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let row" class="action-button">
                  <div class="get-link-action-column">
                    @if (row.discount_rule_type?.discount_rule_type_name === 'Restricted') {
                      <span matTooltip="Restricted codes are not authorized for use by Affiliates - commission will not be awarded" class="restricted-code">
                        Restricted Code
                      </span>
                    } @else {
                      <button class="blue get-link-button" mat-raised-button (click)="onGetLinkClick(row); triggerAnalytics('Discounts_GetLink_button', 'Discounts')"><img height="16" width="17" [ngSrc]="'/assets/images/logo-symbol-on-dark.svg' | absUrl"> Get Link</button>&nbsp;
                    }
                    @if(row.showNewLabel) {
                      <div>
                        <span class="chip-like new-label" matTooltip="Modified within seven days">New</span>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="discount_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Discount Title</th>
                <td mat-cell *matCellDef="let row">
                  <a class="discount-title-text" [href]="row.discount_url" target="_blank" rel="noopener">{{row.discount_name | titlecase}}</a>
                </td>
              </ng-container>

              <ng-container matColumnDef="discount_description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Discount Details</th>
                <td mat-cell *matCellDef="let row">{{row.discount_description}}</td>
              </ng-container>

              <ng-container matColumnDef="discount_entity_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Designated Affiliates</th>
                <td mat-cell *matCellDef="let row">
                  @if(row.discount_entity_name === 'all' || row.discount_entity_name === 'none') {
                    <ng-container>
                      {{row.discount_entity_name | titlecase}}
                    </ng-container>
                  } @else {
                    <ng-container>
                      <a (click)="onClickAffiliates(row)">{{row.discount_entity_group_name === 'tag_groups' ? 'Tag Group: ' + (row.discount_entity_name | titlecase) : (row.discount_entity_name | titlecase)}}</a>
                    </ng-container>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="merchant_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Merchant</th>
                <td mat-cell *matCellDef="let row">
                  <span class="merchant-title-text">{{row.merchant.merchant_name | titlecase}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="coupon_code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Coupon Code</th>
                <td mat-cell *matCellDef="let row">
                  <div class="coupon-code-chips">
                    @if (row.showCouponTooltip) {
                      <span class="coupon-code" matTooltip="An * indicates a wildcard coupon code - wildcard codes are a series of one use codes - contact merchant for more information about specific codes.">{{row.coupon_code}}</span>
                    }
                    @else {
                      @if (row.coupon_code !== null && row.coupon_code !== "") {
                        <span class="chip-like coupon-code">{{row.coupon_code}}</span>
                      } @else {
                        <span><i>Automatic: No code needed</i></span>
                      }
                    }
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="discount_rule_type_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Rule Type</th>
                <td mat-cell *matCellDef="let row" [matTooltip]="row.ruleTypeTooltip !==null ? row.ruleTypeTooltip : null">{{(row.discount_rule_type?.discount_rule_type_name | titlecase) ?? 'None'}}</td>
              </ng-container>

              <ng-container matColumnDef="discount_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let row">{{row.discount_status | titlecase}}</td>
              </ng-container>

              <ng-container matColumnDef="started_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
                <td mat-cell *matCellDef="let row">{{row.started_at | date:'mediumDate'}}</td>
              </ng-container>

              <ng-container matColumnDef="expired_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                <td mat-cell *matCellDef="let row">{{row.expired_at ? (row.expired_at | date:'mediumDate') : 'N/A' }}</td>
              </ng-container>

              <ng-container matColumnDef="updated_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Update</th>
                <td mat-cell *matCellDef="let row">{{row.lastUpdatedAt ? row.lastUpdatedAt : 'N/A' }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns()"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns()"></tr>

              <tr class="mat-mdc-row" *matNoDataRow>
                @if (isLoadingResults()) {
                  <td class="mat-mdc-cell" [attr.colspan]="tableColumns().length">loading...</td>
                }
                @if (!dataError() && !isLoadingResults()) {
                  <td class="mat-mdc-cell" [attr.colspan]="tableColumns().length">No discount results.</td>
                }
                @if (dataError() && !isLoadingResults()) {
                  <td class="mat-mdc-cell" [attr.colspan]="tableColumns().length">An error occurred getting discounts.</td>
                }
              </tr>
            </table>
          </div>

          <mat-paginator [length]="totalItems()" [pageSizeOptions]="[5, 10, 25, 100]" pageSize="25" showFirstLastButtons></mat-paginator>
        </div>
      </mat-card>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
